angular.module('aprima-core-ui').directive('apSaveToFile',
    ['BrowserService', '_',
        function (BrowserService, _) {
            'use strict';

            function link($scope, element) {

                var imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'rtf', 'doc', 'docx', 'tif', 'tiff'];
                var htmlFormats = ['html', 'htm', 'xml'];
                var textFormats = ['txt'];
                var pdfFormat = ['pdf'];

                function _saveAsFile(fileNameToSaveAs, base64String, contentType) {
                    BrowserService.downloadDocumentToFile(fileNameToSaveAs, base64String, contentType, document);
                }

                function _onClick() {
                    $scope.loadText()
                        .then(function (attachment) {
                            if (attachment) {

                                $scope.attachment = attachment;
                                $scope.attachment.attachmentData = attachment.Data;

                                $scope.isPdf = _.includes(pdfFormat, attachment.Extension);
                                $scope.isImage = _.includes(imageFormats, attachment.Extension);
                                $scope.isHtml = _.includes(htmlFormats, attachment.Extension);
                                $scope.isText = _.includes(textFormats, attachment.Extension);

                                var fileName = $scope.fileName || attachment.FileName;

                                if($scope.isPdf){
                                    _saveAsFile(fileName + '.pdf', $scope.attachment.attachmentData, 'application/pdf');
                                }
                                else if($scope.isImage) {
                                    _saveAsFile(fileName + '.' + attachment.Extension, $scope.attachment.attachmentData, 'image/' + attachment.Extension);
                                }
                                else if($scope.isHtml) {
                                    _saveAsFile(fileName + '.html', $scope.attachment.attachmentData, 'text/html; charset=utf-8');
                                }
                                else if($scope.isText) {
                                    _saveAsFile(fileName + '.txt', $scope.attachment.attachmentData, 'text/html; charset=utf-8');
                                }
                            }
                        });
                }

                element.on('click', _onClick);
                $scope.$on('$destroy', function () {
                    element.off('click');
                });
            }

            return {
                restrict: 'A',
                scope: {
                    loadText: '&apSaveToFile',
                    fileName: '@'
                },
                link: link
            };
        }]);